(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementHeight extends HTMLElement {
    constructor() {
      super();
      this._rafId = null;
      this._ro = null;
      this._lastHeight = null;

      this.queueMeasure = this.queueMeasure.bind(this);
      this.measure = this.measure.bind(this);
    }

    connectedCallback() {
      this.queueMeasure();

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(this.queueMeasure);
        this._ro.observe(this);
      }

      window.addEventListener('resize', this.queueMeasure, { passive: true });
      window.addEventListener('orientationchange', this.queueMeasure, { passive: true });
      window.addEventListener('load', this.queueMeasure, { once: true });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.queueMeasure);
        document.addEventListener('shopify:section:unload', this.queueMeasure);
        document.addEventListener('shopify:section:select', this.queueMeasure);
        document.addEventListener('shopify:section:deselect', this.queueMeasure);
        document.addEventListener('shopify:block:select', this.queueMeasure);
        document.addEventListener('shopify:block:deselect', this.queueMeasure);
      }
    }

    disconnectedCallback() {
      if (this._ro) {
        this._ro.disconnect();
        this._ro = null;
      }

      if (this._rafId) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }

      window.removeEventListener('resize', this.queueMeasure);
      window.removeEventListener('orientationchange', this.queueMeasure);

      if (window.Shopify && Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.queueMeasure);
        document.removeEventListener('shopify:section:unload', this.queueMeasure);
        document.removeEventListener('shopify:section:select', this.queueMeasure);
        document.removeEventListener('shopify:section:deselect', this.queueMeasure);
        document.removeEventListener('shopify:block:select', this.queueMeasure);
        document.removeEventListener('shopify:block:deselect', this.queueMeasure);
      }
    }

    queueMeasure() {
      if (this._rafId) return;
      this._rafId = requestAnimationFrame(this.measure);
    }

    measure() {
      this._rafId = null;

      const height = this.offsetHeight;

      if (height === this._lastHeight) return;
      this._lastHeight = height;

      document.documentElement.style.setProperty('--announcement-height', `${height}px`);
    }
  }

  if (!customElements.get('announcement-height')) {
    customElements.define('announcement-height', AnnouncementHeight);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this._rafId = null;
      this._resizeObserver = null;
      this._lastHeaderHeight = null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.updateHeaderHeight = this.updateHeaderHeight.bind(this);
      this.queueHeaderHeightUpdate = this.queueHeaderHeightUpdate.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.queueHeaderHeightUpdate();

      window.addEventListener('resize', this.queueHeaderHeightUpdate, { passive: true });
      window.addEventListener('orientationchange', this.queueHeaderHeightUpdate, { passive: true });
      window.addEventListener('load', this.queueHeaderHeightUpdate, { once: true });
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.queueHeaderHeightUpdate);
      if ('ResizeObserver' in window && this.header) {
        this._resizeObserver = new ResizeObserver(() => {
          this.queueHeaderHeightUpdate();
        });
        this._resizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    queueHeaderHeightUpdate() {
      if (this._rafId) return;
      this._rafId = requestAnimationFrame(() => {
        this._rafId = null;
        this.updateHeaderHeight();
      });
    }

    updateHeaderHeight() {
      const height = this.header.offsetHeight;

      if (height !== this._lastHeaderHeight) {
        this._lastHeaderHeight = height;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.queueHeaderHeightUpdate);
      window.removeEventListener('orientationchange', this.queueHeaderHeightUpdate);

      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }

      if (this._rafId) {
        cancelAnimationFrame(this._rafId);
        this._rafId = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
